import React, { useState } from 'react';
import {
  Container,
  Typography,
  Switch,
  FormControlLabel,
  Box,
  Button,
} from '@mui/material';

const Setting: React.FC = () => {
  const [excludeOpened, setExcludeOpened] = useState(localStorage.getItem('excludeOpened') === 'true');

  const handleToggle = () => {
    setExcludeOpened(!excludeOpened);
    // Save the setting to local storage or context
    localStorage.setItem('excludeOpened', JSON.stringify(!excludeOpened));
  };

  return (
    <Container maxWidth="sm">
      <Box textAlign="center" mt={5}>
        <Typography variant="h4" gutterBottom>
          Settings
        </Typography>
        <FormControlLabel
          control={<Switch checked={excludeOpened} onChange={handleToggle} />}
          label="Exclude opened cards"
        />
        <div>
          <Button
            variant="contained"
            color="secondary"
            href="/"
            style={{ marginTop: '20px' }}
          >
            Back to Home
          </Button>
        </div>
      </Box>
    </Container>
  );
};

export default Setting;
